var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('FormBox',{ref:"FormBox",attrs:{"action":_vm.$api.url_upload_pu,"formItems":_vm.formItems},on:{"submit":_vm.formSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }